import React, { ReactElement } from "react";
import classnames from "classnames";
import { Loader, LoaderPosition } from "../Loader";

import "./LocalLoader.scss";

interface Props {
  children: ReactElement;
}

export const LocalLoader = () => {
  return <Loader position={LoaderPosition.Local} />;
};

export const LocalLoaderWrapper = ({ children }: Props) => {
  const loaderWrapperClassName = classnames(
    "local-loader-wrapper",
    children.props.className
  );
  return React.cloneElement(children, { className: loaderWrapperClassName });
};
